import { $api } from "../AxiosInstance";

export class CountryService {
  static async countriesGetAll() {
    return await $api.get("/api/admin/country/all");
  }

  static async countriesGet(id) {
    return await $api.get("/api/admin/country", { params: { id } });
  }

  static async countriesDelete(id) {
    return await $api.delete("/api/admin/country", { params: { id } });
  }

  static async countriesSave(params) {
    return await $api.post("/api/admin/country", params);
  }

  static async countriesCreate(params) {
    return await $api.put("/api/admin/country", params);
  }

  static async changeCountryOrder(countriesSortedIds) {
    return await $api.post("/api/admin/country/changeIndices", {
      countriesSortedIds,
    });
  }
}
